import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { IdentityDocumentTypesService } from 'src/app/services/identitydocumenttypes.service';
import { IdentityDocumentTypesModalComponent } from './identitydocumenttypes-modal/identitydocumenttypes-modal.component';




@Component({
  selector: 'app-identitydocumenttypes',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './identitydocumenttypes.component.html',
  styleUrls: ['./identitydocumenttypes.component.css']
})
export class IdentityDocumentTypesComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private IdentityDocumentTypesService: IdentityDocumentTypesService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  IdentityDocumentTypesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getIdentityDocumentTypes();
  }

  getIdentityDocumentTypes(){
    this.IdentityDocumentTypesService.getIdentityDocumentTypes().subscribe({
      next: (res: any) => {
        this.IdentityDocumentTypesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(IdentityDocumentTypesModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getIdentityDocumentTypes();
        }
      }
    });
  }

}
